import { render, staticRenderFns } from "./feeDisplayNamesSetting.vue?vue&type=template&id=e72763f0&scoped=true"
import script from "./feeDisplayNamesSetting.vue?vue&type=script&lang=ts"
export * from "./feeDisplayNamesSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72763f0",
  null
  
)

export default component.exports